export default __webpack_public_path__ + "static/media/7.b2a42991.png";